import { cn } from '@/lib/utils'
import React from 'react'
import { CommandLoading } from 'cmdk'
import { Spinner } from '../spinner'
import { CommandEmpty } from '../command'
import { ChevronDown } from 'lucide-react'
import { ZyguanbiTianchongIcon } from '@/component'

type ComboboxTriggerProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  selected?: boolean
  activeLight?: boolean
  allowClear?: boolean
  hideClear?: boolean
  onClear?: () => void
  customDownIcon?: React.ReactNode
  variant?: 'default' | 'outline'
}

export const ComboboxTrigger = React.forwardRef<HTMLButtonElement, ComboboxTriggerProps>(
  (
    {
      children,
      className,
      allowClear,
      hideClear = false,
      selected,
      activeLight = false,
      onClear,
      customDownIcon,
      variant = 'default',
      disabled,
      ...rest
    }: ComboboxTriggerProps,
    ref,
  ) => (
    <button
      className={cn(
        'group h-8 inline-flex w-fit items-center justify-between rounded bg-background px-2 py-1 hover:bg-hover active:bg-active',
        variant === 'outline' && 'border border-input rounded-md',
        className,
        disabled && 'text-muted-foreground cursor-not-allowed',
        selected && activeLight && 'text-accent bg-accent-select hover:bg-accent-select active:bg-accent-select',
      )}
      ref={ref}
      {...rest}
    >
      <div className="line-clamp-1 break-all text-left">{children}</div>

      {!hideClear && allowClear && selected ? (
        <ZyguanbiTianchongIcon
          onClick={(e) => {
            e.stopPropagation()
            onClear?.()
          }}
          className="hidden ml-2 h-4 w-4 shrink-0 text-muted-foreground transition-transform group-aria-expanded:pointer-events-none group-hover:block group-active:text-muted-foreground-2"
        />
      ) : (
        <></>
      )}
      <div className={cn('block', { 'group-hover:hidden': allowClear && selected })}>
        {customDownIcon || <ChevronDown className="ml-2 h-4 w-4 shrink-0 transition-transform group-aria-expanded:rotate-180" />}
      </div>
    </button>
  ),
)

export function ComboboxLoading() {
  return (
    <CommandLoading>
      <Spinner className="h-20">Loading...</Spinner>
    </CommandLoading>
  )
}

export function ComboboxEmpty() {
  return <CommandEmpty>暂无数据</CommandEmpty>
}
